import React from 'react';

export default function TinyBootsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Left boot */}
      <path d="M4 14C4 14 4 28 4 30C4 34 6 36 14 36L14 30C14 30 14 14 14 14Z" fill="#8B5E3C" rx="2" />
      <rect x="4" y="14" width="10" height="22" rx="3" fill="#8B5E3C" />
      {/* Left boot toe */}
      <path d="M4 32C4 36 6 36 14 36L16 36C18 36 18 34 18 32C18 30 14 30 14 30L4 30Z" fill="#7A4E2C" />
      {/* Left boot sole */}
      <rect x="3" y="35" width="16" height="3" rx="1.5" fill="#4A3020" />
      {/* Left boot top trim */}
      <rect x="4" y="14" width="10" height="3" rx="1" fill="#A87050" />
      {/* Left boot stitching */}
      <line x1="6" y1="20" x2="12" y2="20" stroke="#6B4423" strokeWidth="0.5" strokeDasharray="1.5 1" />
      <line x1="6" y1="26" x2="12" y2="26" stroke="#6B4423" strokeWidth="0.5" strokeDasharray="1.5 1" />
      {/* Right boot */}
      <rect x="22" y="14" width="10" height="22" rx="3" fill="#8B5E3C" />
      {/* Right boot toe */}
      <path d="M22 30L22 32C22 34 22 36 22 36L32 36C36 36 36 34 36 32L32 30Z" fill="#7A4E2C" />
      {/* Right boot sole */}
      <rect x="21" y="35" width="16" height="3" rx="1.5" fill="#4A3020" />
      {/* Right boot top trim */}
      <rect x="22" y="14" width="10" height="3" rx="1" fill="#A87050" />
      {/* Right boot stitching */}
      <line x1="24" y1="20" x2="30" y2="20" stroke="#6B4423" strokeWidth="0.5" strokeDasharray="1.5 1" />
      <line x1="24" y1="26" x2="30" y2="26" stroke="#6B4423" strokeWidth="0.5" strokeDasharray="1.5 1" />
    </svg>
  );
}
